/* eslint-disable import/prefer-default-export */
import * as network from './player';
import * as marietta3d from '../../view3d';
import { ThreeView } from '../../../marietta/view3d/webcad';

const timeLimit = 300;// 5 minute
export class Timer implements network.playerStatus {
  interval: any;

  timeLeft: number;
  displayTime: string

  // コンストラクタ
  constructor() {
    this.timeLeft = timeLimit;
  }

  // eslint-disable-next-line class-methods-use-this
  onChange(status: number): void {
    if (status === 1) {
      this.startTimer();
    } else {
      this.stopTimer();
    }
  }

  /**
   *タイマーを開始
   */
  public startTimer() {
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft -= 1;
        let minute: string = Math.floor(this.timeLeft / 60).toString();
        minute = (minute.length === 1) ? `0${minute}` : minute;
        let second: string = (this.timeLeft - Number(minute) * 60).toString();
        second = (second.length === 1) ? `0${second}` : second;
        const displayTime = `${minute} : ${second}`;
        document.getElementById('servertimer').innerHTML = displayTime;
      } else {
        this.timeLeft = timeLimit;
        if (document.getElementById('servertimerContainer')) {
          document.getElementById('servertimerContainer').innerHTML = '';
        }
        this.stopTimer();
      }
    }, 1000);
  }

  /**
   * タイマーを止める
   */
  public stopTimer() {
    clearInterval(this.interval);
    this.timeLeft = timeLimit;
    // Pixelstreaming接続解除
    const psCommunication = marietta3d.webcad.ThreeView.get().pscommunication;
    psCommunication.disconnect();
    if (document.getElementById('servertimerContainer')) {
      document.getElementById('servertimerContainer').innerHTML = '';
    }
  }

  /**
   * 一時停止タイマー
   */
  public pauseTimer() {
    clearInterval(this.interval);
  }
}
